/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {useDispatch} from 'react-redux'
import {Link, useNavigate} from 'react-router-dom'
import {logout} from '../../../../api/modules/auth'
import {useAuth} from '../../../../app/modules/auth'
import {setLogout} from '../../../redux/content'
import styled from 'styled-components'
import {useAppDispatch} from '../../../../redux/hooks'
import {setAuthUser, setCredential} from '../../../../redux/slices/authSlices'
import {LogoutMenu} from 'src/components/LogoutMenu/LogoutMenu'

const Wrapper = styled.div`
  z-index: 100000 !important;
`

const HeaderUserMenu: FC = () => {
  const navigate = useNavigate()
  const dispath = useDispatch()
  const appDispatch = useAppDispatch()
  const {t} = useTranslation()

  const [logoutLoading, setLogoutLoading] = useState(false)

  const keluar = async () => {
    setLogoutLoading(true)
    try {
      var res = await logout(localStorage.getItem('token'))
      console.log(res.data)
      removeStorage()
      dispath(setLogout())
      appDispatch(setAuthUser(null))
      appDispatch(setCredential(null))
      navigate('/auth')
      setLogoutLoading(false)
    } catch {
      removeStorage()
      navigate('/auth')
      setLogoutLoading(false)
    }
  }

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    localStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  const {currentUser} = useAuth()

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')

  useEffect(() => {
    const username = () => {
      const name: any = localStorage.getItem('username')
      const email: any = localStorage.getItem('email')
      setName(name)
      setEmail(email)
    }

    username()
  }, [])

  return (
    <Wrapper
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img
              src={`https://ui-avatars.com/api/?name=${
                name != 'null' ? name : 'customer'
              }&background=274070&color=fff`}
              alt='Logo'
            />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-ditems-center fs-5'>
              {localStorage.getItem('username')}
            </div>
            <p
              className='fw-bold text-muted text-hover-primary fs-7'
              style={{
                width: '170px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {email != 'null' ? email : 'customer@gmail.com'}
            </p>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      {/* <div className='menu-item px-5 my-1'>
        <Link to='/change-password' className='menu-link px-5'>
          {t('Change Password')}
        </Link>
      </div> */}

      <div className='menu-item px-5 my-1'>
        <Link to='/crafted/account/settings' className='menu-link px-5'>
          {t('Account Settings')}
        </Link>
      </div>

      <div className='menu-item px-5'>
        <LogoutMenu isLoading={logoutLoading} onClick={keluar} />
      </div>
    </Wrapper>
  )
}

export {HeaderUserMenu}
